import { createLogger } from "logging";
import { useSuggestedAgendaItemPanel } from "providers";
import React from "react";

const logger = createLogger("SuggestedAgendaItemsSelection");

interface SuggestedAgendaItemsSelectionProps {
  id: number;
}

export const SuggestedAgendaItemsSelection: React.FC<SuggestedAgendaItemsSelectionProps> = ({ id }) => {
  const { selectedIds, onItemChange } = useSuggestedAgendaItemPanel();
  const selected = selectedIds.has(id);

  const onChange = (checked: boolean) => {
    logger.debug("onChange(): id:=", id, ", checked:=", checked);
    onItemChange(id, checked);
  };

  logger.debug(`render(): `, id, selected);
  return (
    <input
      type="checkbox"
      checked={selected}
      onChange={(e) => {
        e.stopPropagation();
        onChange(e.target.checked);
      }}
    />
  );
};
